<div class="row">
  <div class="col-lg-8">
    <div class="mb-4">
      <ng-container [ngTemplateOutlet]="deliveryCard"></ng-container>
    </div>
    <div class="mb-4">
      <ng-container [ngTemplateOutlet]="paymentCard"></ng-container>
    </div>
  </div>
  <div class="col-lg-4">
    <retail-order-info (back)="back.emit()" (next)="continue()"></retail-order-info>
  </div>
</div>

<ng-template #deliveryCard>
  <mat-card>
    <mat-card-header class="pb-2">
      <mat-card-title>
        <span class="pr-2">{{ 'Delivery' | t }}</span>
        <span style="font-size: 66%">{{ 'The weight of the shipment is approx. [0] kg.' | t: [weight + ''] }}</span>
      </mat-card-title>
    </mat-card-header>
    <mat-card-footer>
      <ng-container *ngFor="let item of deliveries">
        <div
          class="list-item"
          [ngClass]="{ 'list-item-selected': item.id === delivery?.id }"
          (click)="chooseDelivery(item)">
          <mat-radio-button
            [name]="item.id"
            [checked]="item.id === delivery?.id"
            color="primary"
            class="col-auto"></mat-radio-button>
          <div class="col-3 d-none d-lg-block">
            <img [lazyLoad]="'/assets/shipments/' + item.id + '.png'" [alt]="item.id" class="icon" />
          </div>
          <div class="col">
            <b>{{ item.title }}</b>
            <ng-container *ngIf="item.id === delivery?.id && item.description">
              <br /><i>{{ item.description }}</i>
            </ng-container>
            <ng-container *ngIf="item.id === delivery?.id && pickup">
              <br />
              <i>
                <span>{{ pickup.deliveryName }}</span>
              </i>
            </ng-container>
          </div>
          <div class="col-auto">
            <b *ngIf="item.price === 0">{{ 'Free' | t }}</b>
            <b *ngIf="item.price > 0">{{ item.price | localeCurrency }}</b>
          </div>
        </div>
      </ng-container>
      <div *ngIf="submitted && !delivery" class="p-3 text-warn">{{ 'You must choose a delivery!' | t }}</div>
    </mat-card-footer>
  </mat-card>
</ng-template>

<ng-template #paymentCard>
  <mat-card>
    <mat-card-header class="pb-2">
      <mat-card-title
        ><span>{{ 'Payment' | t }}</span></mat-card-title
      >
    </mat-card-header>
    <mat-card-footer>
      <ng-container *ngFor="let item of payments">
        <div
          class="list-item"
          [ngClass]="{ 'list-item-selected': item.id === payment?.id }"
          (click)="choosePayment(item)">
          <mat-radio-button
            [name]="item.id"
            [checked]="item.id === payment?.id"
            color="primary"
            class="col-auto"></mat-radio-button>
          <div class="col-auto list-item-icon"></div>
          <div class="col">
            <b>{{ item.title }}</b>
          </div>
          <div class="col-auto">
            <b *ngIf="item.price === 0">{{ 'Free' | t }}</b>
            <b *ngIf="item.price > 0">{{ item.price | localeCurrency }}</b>
          </div>
        </div>
      </ng-container>
      <div *ngIf="submitted && !payment" class="p-3 text-warn">{{ 'You must choose a payment!' | t }}</div>
    </mat-card-footer>
  </mat-card>
</ng-template>

<!--  <div *ngIf="isDeliveryCzechPostPickup" class="portlet">-->
<!--    <div class="portlet__head">Výběr pošty</div>-->
<!--    <div class="portlet__body">-->
<!--      <app-checkout-czechpost-->
<!--        (pickupChosen)="pickupChosen($event)"-->
<!--        [code]="form.value.postCode"-->
<!--        [postAddress]="form.value.postAddress"></app-checkout-czechpost>-->
<!--      <div *ngIf="postCodeError" class="p-3 text-warn">-->
<!--        {{ 'Musíte zadat platné PSČ!' }}-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
